<script setup>

import AppLayout from "@/layouts/AppLayout.vue";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { GetOrganisation } from "@/services/organisationService.js";
import { GetApp } from "@/services/appService.js";
import { getContext } from "@/services/context.js";
import { CreatePanel, GetPanels } from "@/services/panelsService.js";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card/index.js";
import { Label } from "@/components/ui/label/index.js";
import { Input } from "@/components/ui/input/index.js";
import { ChevronRight, Loader } from "lucide-vue-next";
import { Button } from "@/components/ui/button/index.js";
import ErrorAlert from "@/components/ui/error-alert.vue";

const route = useRoute();
const router = useRouter();

const organisation = ref(null);
const app = ref(null);
const isLoading = ref(true);
const name = ref('')
const error = ref(null)

onMounted(async () => {
  organisation.value = await GetOrganisation(getContext(route));
  app.value = await GetApp(getContext(route), route.params.appId);

  isLoading.value = false;
});

async function onSubmit(event) {
  event.preventDefault();
  isLoading.value = true;

  try {
    let response = await CreatePanel(getContext(route), name.value);
    await router.push({ path: `/${route.params.organisationId}/app/${route.params.appId}/panel/${response.token}` });
  } catch (err) {
    error.value = err;
  } finally {
    isLoading.value = false;
  }
}
</script>

<template>
  <AppLayout :organisation="organisation" :app="app">
    <div class="flex-1 space-y-4 pt-8">
      <div class="container mx-auto max-w-2xl">
        <Card class="w-full mx-auto">
          <CardHeader>
            <CardTitle class="text-2xl">
              Create a panel
            </CardTitle>
          </CardHeader>
          <CardContent class="grid gap-4">
            <ErrorAlert v-if="error" :error="error" />
            <div class="grid gap-2">
              <div>
                <Label for="name">Name</Label>
                <Input id="name" type="text" placeholder="Helpful panel" required :disabled="isLoading"
                  v-model="name" />
              </div>
            </div>
          </CardContent>
          <CardFooter>
            <Button class="w-1/3 mr-8" @click="router.back()" variant="ghost" :disabled="isLoading">
              Cancel
            </Button>

            <Button class="w-2/3" @click="onSubmit" :disabled="isLoading">
              <Loader v-if="isLoading" class="mr-2 h-4 w-4 animate-spin" />
              Create
              <ChevronRight />
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  </AppLayout>
</template>

<style scoped></style>